import { Priority, TodoStatus } from "../../../utils/backend-types";
import type { FormFieldData } from "../../BuildingBlocks/Forms/Controllers/FormFieldController";
import { PRIORITIES } from "../Todos.constants";

export interface TodoFormValues {
  label: string;
  regulatoryDutyId: number | null;
  personId: number | null;
  dueDate: string | null;
  overdue: boolean;
  responsible: number | null;
  priority: Priority;
  status: TodoStatus;
}

export const TODO_FORM_FIELD_DATA = {
  label: {
    name: "label",
    type: "text",
    label: "Bezeichnung",
    required: true
  },
  regulatoryDutyId: {
    name: "regulatoryDutyId",
    type: "custom",
    label: "Regulatorische Pflicht"
  },
  dueDate: {
    name: "dueDate",
    type: "date",
    label: "Fälligkeit"
  },
  overdue: {
    name: "overdue",
    type: "custom",
    label: "Überfällig"
  },
  personId: {
    name: "personId",
    type: "select",
    label: "Verpflichtetes Unternehmen",
    clearable: true
  },
  responsible: {
    name: "responsible",
    type: "select",
    label: "Verantwortlich",
    clearable: true
  },
  priority: {
    name: "priority",
    type: "select",
    label: "Priorität",
    required: true,
    data: PRIORITIES
  },
  status: {
    name: "status",
    type: "select",
    label: "Status",
    required: true
  }
} as const satisfies FormFieldData<TodoFormValues>;

export const DEFAULT_TODO_FORM_VALUES: TodoFormValues = {
  label: "",
  regulatoryDutyId: null,
  personId: null,
  dueDate: null,
  overdue: false,
  responsible: null,
  priority: Priority.Unknown,
  status: TodoStatus.Open
};
